<template>
    <div class="healthDataPK">
      <i class="iconfont iconfanhui back" @click.stop="$router.push({path: '/results'})">返回</i>
      <div class="healthDataPK_wrap">
        <div class="healthDataPK_box">
          <p class="title">CER心血管疾病风险得分比较</p>
          <CerRisk :data="proportion"></CerRisk>
        </div>
      </div>
    </div>
</template>

<script>
import CerRisk from '@/components/CerRisk'
export default {
  name: 'healthDataPK',
  data () {
    return {
      proportion: {}
    }
  },
  components: {
    CerRisk
  },
  methods: {
    result () {
      this.util.get(this.api.result, '', (success) => {
        this.proportion = success.data.proportion
      })
    }
  },
  mounted () {
    this.result()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .healthDataPK {
    width: 100%;
    height: 100%;
    background: #C4E3FE;
    position: relative;
    overflow: auto;

    .back {
      position: absolute;
      top: pxToRem(20px);
      left: pxToRem(20px);
      font-size: pxToRem(25px);
      color: #000;
    }

    .healthDataPK_wrap {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(36px);
      margin: pxToRem(92px) auto;

      .healthDataPK_box {
        padding: pxToRem(80px);
        background: #fff;
        border-radius: pxToRem(20px);

        .title {
          font-size: pxToRem(36px);
          font-weight: bold;
          color: #2A6BAE;
          text-align: center;
          letter-spacing: 1px;
          margin-bottom: pxToRem(53px);
        }

        .van-cell {
          background: #C4E3FE;
          border:1px solid #221815;
          opacity: 0.47;
          border-radius: pxToRem(10px);
          font-size: pxToRem(20px);
          color: #000;
          margin: pxToRem(45px) 0;
        }
        .van-grid {
          font-size: pxToRem(20px);
        }
      }

      .notHave {
        width: pxToRem(300px);
        margin: pxToRem(56px) auto 0;
        text-align: center;

        .van-checkbox__label {
          font-weight: bold;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/views/ceramide/healthDataPK.vue